import(/* webpackMode: "eager", webpackExports: ["CookieConsentBanner"] */ "/app/packages/web-next/src/components/CookieConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/packages/web-next/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RUMPageTracker"] */ "/app/packages/web-next/src/components/RUMPageTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundManager"] */ "/app/packages/web-next/src/components/ui/BackgroundManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WindowSizeProvider"] */ "/app/packages/web-next/src/context/WindowSizeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ObservabilityProvider"] */ "/app/packages/web-next/src/providers/ObservabilityProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/web-next/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/packages/web-next/src/styles/livestreams-global.css");
